import type { NewMemberFieldErrors } from '../hooks/use-new-member-form';

const MESSAGES: Record<string, string> = {
  required: 'Campo requerido',
  email_format: 'Email no válido',
  phone_format: 'Formato de teléfono no válido',
  phone_too_short: 'Número de teléfono incompleto',
  phone_too_long: 'Número de teléfono demasiado largo',
  password_invalid: 'La contraseña no cumple los requisitos',
  password_mismatch: 'Las contraseñas no coinciden',
  under_18: 'Debes ser mayor de 18 años',
  ig_taken: 'Este usuario de Instagram ya está registrado',
  email_taken: 'Este email ya está registrado',
  phone_taken: 'Este teléfono ya está registrado',
  role_invalid: 'Rol no válido',
  status_invalid: 'Estado no válido',
};

export function translateFieldError(code: string): string {
  return MESSAGES[code] ?? code;
}

export function translateErrorMap(
  codes: NewMemberFieldErrors
): NewMemberFieldErrors {
  const out: NewMemberFieldErrors = {};
  (Object.keys(codes) as (keyof NewMemberFieldErrors)[]).forEach((k) => {
    const code = codes[k];
    if (code) out[k] = translateFieldError(code);
  });
  return out;
}
